import React from 'react';
import { Tooltip } from '@mui/material';
import { IconToggleButton, IconToggleGroupContainer } from './IconToggleGroup.styled';

export interface IconToggleOption<T extends string = string> {
  value: T;
  icon: React.ReactNode;
  tooltip?: string;
}

interface IconToggleGroupProps<T extends string = string> {
  options: IconToggleOption<T>[];
  value: T;
  onChange: (value: T) => void;
  ariaLabel?: string;
}

export function IconToggleGroup<T extends string = string>({
  options,
  value,
  onChange,
  ariaLabel,
}: IconToggleGroupProps<T>) {
  return (
    <IconToggleGroupContainer role="group" aria-label={ariaLabel}>
      {options.map((option) => {
        const active = option.value === value;
        const button = (
          <IconToggleButton
            type="button"
            $active={active}
            aria-label={option.tooltip ?? option.value}
            aria-pressed={active}
            onClick={() => onChange(option.value)}
          >
            {option.icon}
          </IconToggleButton>
        );

        return option.tooltip ? (
          <Tooltip key={option.value} title={option.tooltip} placement="bottom" arrow>
            {button}
          </Tooltip>
        ) : (
          <React.Fragment key={option.value}>{button}</React.Fragment>
        );
      })}
    </IconToggleGroupContainer>
  );
}

export default IconToggleGroup;
